// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"c7bbfb0f","95":"067b52fd","752":"68b69b52"}[chunkId] + ".chunk.css";
};